import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  input: css`
    display: none;
  `,
}
